import { render, staticRenderFns } from "./debt_amount.vue?vue&type=template&id=07f3c98c&"
import script from "./debt_amount.vue?vue&type=script&lang=js&"
export * from "./debt_amount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports